
/*
    add a country prefix to the given path if needed. Assuming that a "country" was defined in the page's props
*/
export function buildPath(route) {
    return route;
}